// 新聞標語

const NewsWarning = ({ t }) => {
    return (
        <div className="text-btn1 text-black flex items-center gap-x-[20px] usm:gap-x-[10px]">
            <p className="flex-shrink-0">{` ・ ${t('REFERENCE')} `}</p>
            <p className="flex-grow w-full h-[1px] border-t-1 border-dashed border-black9" />
        </div>
    );
};

export default NewsWarning;
